import { useEffect, useState } from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import {
  useFreshShipmentCacheInvalidation,
  useUpdateFertTransaction,
} from '@/services/fresh-shipment/hooks';

import { BILL_OPTIONS } from '../utils/constants';

interface BillingDropdownProps extends ICellRendererParams {
  props: ICellRendererParams;
}

export const BillingDropdown = (props: BillingDropdownProps) => {
  const invalidateCache = useFreshShipmentCacheInvalidation();
  const propValue: string | null =
    props.value == null ? null : props.value.toString();
  const [value, setValue] = useState(propValue);

  const { mutateAsync: updateFertilization } = useUpdateFertTransaction();

  const updateBillingDropdownAfterChange = useFeatureFlag(
    'fs_update_billing_dropdown_after_change',
  );
  useEffect(() => {
    if (!updateBillingDropdownAfterChange) return;

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setValue(propValue);
  }, [propValue, updateBillingDropdownAfterChange]);

  const handleChange = (event: DropdownChangeEvent) => {
    const newValue = event.target.value;
    setValue(newValue);

    const gridApi = props.api;
    const selectedNodes = gridApi.getSelectedNodes();
    if (selectedNodes.length > 1) {
      selectedNodes.forEach((node) => {
        updateFertilization({
          id: node.data.fertilizationId,
          field: props?.column?.getColId(),
          value: newValue,
          updatePredictedComments: false,
        }).then(() => {
          invalidateCache(['FertilizationListFreshShipment']);
        });
      });
    } else {
      props?.setValue?.(newValue);
    }
  };

  return (
    <Dropdown
      key={value}
      value={value}
      onChange={handleChange}
      options={BILL_OPTIONS}
      optionLabel="text"
      optionValue="value"
      className="billing-dropdown"
    />
  );
};
